import exportFromJSON from "export-from-json";
export const handleExportReportsData = (data: any, fileName: string) => {
    const exportType = exportFromJSON.types.xls;
    exportFromJSON({ data, fileName, exportType });
}